import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, PackageSearch } from 'lucide-react';
import { SkeletonBox } from '../SkeletonLoader';
import { CODES, shipmentsApi } from '../../utils/shipmentsApi';
import { buildListUrl } from './useShipmentFilters';
import { useRemote } from './useRemote';
import './shipments.css';

const TILES = [
  { key: 'active', label: 'Aktivní', url: buildListUrl({ tab: 'active' }) },
  { key: 'expectedToday', label: 'Očekávané dnes', url: buildListUrl({ tab: 'active', sort: 'expected', order: 'asc' }) },
  { key: 'delayed', label: 'Zpožděné', url: buildListUrl({ tab: 'active', highlight: 'delayed' }), alert: true },
  { key: 'problem', label: 'Problémové', url: buildListUrl({ tab: 'active', highlight: 'problem' }), alert: true },
  { key: 'reviewCount', label: 'Ke kontrole', url: buildListUrl({ tab: 'review' }), alert: true },
];

const cardStyle = { backgroundColor: '#FFF', borderRadius: 12, border: '1px solid #E0E0E0', padding: 20, marginBottom: 24 };

// Dashboard card "Zásilky" (admins only: the parent does not render it for anybody else, so nothing is requested).
// A locked module shows the invitation to verify; any other failure is shown quietly.
const ShipmentsDashboardCard = () => {
  const summary = useRemote('summary', () => shipmentsApi.summary());
  const err = summary.error;
  if (err?.code === CODES.NO_ACCESS) return null;
  const locked = err?.code === CODES.VERIFICATION_REQUIRED;

  return (
    <section style={cardStyle} aria-labelledby="shp-dash-title">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', margin: '0 0 16px' }}>
        <h2 id="shp-dash-title" style={{ fontSize: 18, fontWeight: 600, color: '#333', margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
          <PackageSearch size={20} color="#E53935" aria-hidden="true" /> Zásilky
        </h2>
        <Link to="/zasilky" className="shp-small" style={{ fontWeight: 600 }}>Otevřít modul</Link>
      </div>

      {locked && (
        <p role="status" style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', fontSize: 14, color: '#555' }}>
          <Lock size={16} aria-hidden="true" /> Modul je zamčený –{' '}
          <Link to="/zasilky" style={{ fontWeight: 600 }}>ověřit kódem</Link>
        </p>
      )}
      {err && !locked && <p role="alert" style={{ margin: 0, fontSize: 14, color: '#C62828' }}>Zásilky se nepodařilo načíst. {err.message}</p>}
      {!err && !summary.data && <SkeletonBox height="56px" />}
      {!err && summary.data && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: 10 }}>
          {TILES.map((t) => {
            const n = Number(summary.data[t.key]) || 0;
            return (
              <Link key={t.key} to={t.url} className="shp-dtile">
                <span style={{ display: 'block', fontSize: 26, fontWeight: 700, lineHeight: 1.15, fontVariantNumeric: 'tabular-nums', color: t.alert && n > 0 ? '#C62828' : '#333' }}>{n}</span>
                <span style={{ display: 'block', fontSize: 13, color: '#666', marginTop: 2 }}>{t.label}</span>
              </Link>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default ShipmentsDashboardCard;
